import { selectorInert } from '../utils/a11y';

export default function () {
  document.addEventListener('DOMContentLoaded', () => {
    const id = 'modalSuccessMessage';
    const dialog = document.getElementById(id);

    if (!dialog) {
      return;
    }

    const selectorDomInert = document.querySelectorAll(selectorInert);
    const buttonsTrigger = document.querySelectorAll(`[data-trigger-modal="${id}"]`);

    document.querySelector('#teleport-body').appendChild(dialog);

    function onShow() {
      dialog.showModal();

      selectorDomInert.forEach((dom) => {
        dom.setAttribute('inert', '');
      });
    }

    function onClose(event) {
      if (event.target === dialog) {
        dialog.close();
        removeInertAttribute();
      }
    }

    function removeInertAttribute() {
      selectorDomInert.forEach((dom) => {
        dom.removeAttribute('inert');
      });
    }

    dialog.addEventListener('click', onClose);

    if (buttonsTrigger) {
      buttonsTrigger.forEach((button) => {
        button.addEventListener('click', onShow);
      });
    }

    dialog.addEventListener('close', (event) => {
      removeInertAttribute();
    });
  });
}
